var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sponsor-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l(Math.ceil(_vm.banner.slides.length / 4), function (i) {
    return [_c('div', {
      key: i,
      staticClass: "swiper-slide .mobile d-lg-none"
    }, [_c('v-row', _vm._l(6, function (j) {
      return _c('v-col', {
        key: j,
        attrs: {
          "cols": "4"
        }
      }, [_vm.banner.slides[(i - 1) * 6 + j - 1] ? _c('v-card', {
        staticClass: "border-radius-16 mx-auto",
        attrs: {
          "img": _vm.banner.slides[(i - 1) * 6 + j - 1].image,
          "color": "grey lighten-3",
          "outlined": "",
          "max-width": "220"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      })], 1) : _vm._e()], 1);
    }), 1)], 1)];
  }), _vm._l(Math.ceil(_vm.banner.slides.length / 10), function (i) {
    return [_c('div', {
      key: i,
      staticClass: "swiper-slide d-none d-lg-block"
    }, [_c('v-row', {
      staticClass: "sponsor-list"
    }, _vm._l(10, function (j) {
      return _c('v-col', {
        key: j,
        staticClass: "sponsor-list__item"
      }, [_vm.banner.slides[(i - 1) * 10 + j - 1] ? _c('v-card', {
        staticClass: "border-radius-16 mx-auto",
        attrs: {
          "img": _vm.banner.slides[(i - 1) * 10 + j - 1].image,
          "color": "grey lighten-3",
          "outlined": "",
          "max-width": "220"
        }
      }, [_c('v-responsive', {
        attrs: {
          "aspect-ratio": 1
        }
      })], 1) : _vm._e()], 1);
    }), 1)], 1)];
  })], 2)]), _c('v-btn', {
    staticClass: "swiper-prev",
    attrs: {
      "icon": "",
      "outlined": "",
      "x-large": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _c('v-btn', {
    staticClass: "swiper-next",
    attrs: {
      "icon": "",
      "outlined": "",
      "x-large": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }